<template>
<f7-page name="edit-user-profile">
  <bc-navbar></bc-navbar>
  <div class="page_maincontent layout_fullwidth_padding">
    <a v-on:click="back">
      <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="">
    </a>
    <h2 class="page_title margin_left_none">My Profile Information</h2>
    <f7-list class="no-hairlines no_list_bootm_border margin_top_none" form>
      <f7-list-item>
        <f7-label>First Name</f7-label>
        <f7-input type="text" name="First Name" v-model="profile.firstName" v-validate="'required|alpha'" />
        <span v-show="errors.has('First Name')" class="error-message">
          {{ errors.first('First Name') }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Last Name</f7-label>
        <f7-input type="text" name="Last Name" v-model="profile.lastName" v-validate="'required|alpha'" />
        <span v-show="errors.has('Last Name')" class="error-message">
          {{ errors.first('Last Name') }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Mobile Phone</f7-label>
        <div class="item-input item-input-field not-empty-state" masked="true" data-vv-id="6"  aria-invalid="false" v-if='isLoadData'>
              <vue-tel-input 
              data-vv-name="Phone"
              v-model="profile.mobilePhone" 
              :phone='profile.mobilePhone'
              v-validate.continues="{ required: true, phone: true }"
              :invalid="errors.first('Phone')"
              ></vue-tel-input>            
        </div>
         <span v-if="invalidPhone" class="error-message">
          {{errors.first('Phone')}}
        </span>      
      </f7-list-item>
      <f7-list-item v-if="profile.optSmsStatusMessage != 0 && profile.mobilePhone && !errors.has('Mobile Phone')" >
         <div class="form_row_right" >       
            <label class="label-checkbox item-content">
              <!-- Checked by default -->
              <input type="checkbox" name="message-checkbox" v-model="profile.isOptIn" :checked="profile.optSmsStatus == 1" :disabled="profile.optSmsStatusMessage == 0">
                <div class="item-media">
                  <i class="icon icon-form-checkbox"></i>
                </div>            
                <div style='float:left'> I agree to receive SMS messages from {{salesPersonFullName}} and {{companyName}}.</div>              
            </label>
          </div>
           <div class="form_row_right" v-if="profile.optSmsStatusMessage == 0">       
            <label class="label-checkbox item-content">
              <span class='font-red'> You sent STOP on {{profile.optSmsDataChange}}. Please reply Start to {{companyPhone}}</span>
            </label>
          </div>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Email</f7-label>
         <div data-v-e93dd5c3="" class="item-input item-input-field not-empty-state" masked="true" data-vv-id="7"  aria-invalid="false">
           <input type="text" name="Email" v-model="profile.email"  v-validate="'email'" class="not-empty-state"/>
         </div>
        <!-- <f7-input type="text" name="Email" v-model="profile.email"  v-validate="'email'" /> -->
        <span v-show="errors.has('Email')" class="error-message">
          {{ errors.first('Email') }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <div class='fx align-items-center'>
          <div class="profile_avatar">
            <img v-if="!userImage" src="/static/images/avatar.jpg" alt="" title="" />
            <img v-if="userImage" :src="userImage" alt="" title="" />
          </div>
          <label for="fileInput" class="button file_upload" :style="borderStyle" >
            Edit
          </label>
          <input type="file" id="fileInput" @change="uploadProfileImage($event)" name="fileInput" class="file_input_upload"
            accept="image/*" />
        </div>
      </f7-list-item>
      <input type="button" :style="borderStyle" value=" Save Changes" v-if="!saveRequest.isActive && !errors.has('Email') &&  !errors.first('Last Name') && !errors.first('First Name') " @click="saveUserProfile" class="button form_submit"/>
    </f7-list>
      <div v-if="saveRequest.isActive" class="loader">
          <looping-rhombuses-spinner v-if="!saveRequest.isSuccess" :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
          <div class="success_msg" v-if="saveRequest.isSuccess">
              <img src="/static/images/icons/black/success.png" alt="" class="success_icon" title="">
              <div style="margin-left: 10px;">Changes saved!</div>
          </div>
      </div>
  </div>
</f7-page>

</template>

<script>
/* eslint-disable */
import { mapState, mapGetters, mapActions } from "vuex";
import { LoopingRhombusesSpinner } from "epic-spinners";
import {mask} from 'vue-the-mask' 
export default {
  components: {
    LoopingRhombusesSpinner
  },
  directives: {mask},
 mounted: function(){ 
        this.$store.dispatch("editUserProfile/loadUserProfile").catch(x=> {
            this.$f7.mainView.router.load({url: 'error'});
        });
        this.profile = this.getProfile;     
        document.body.className = document.body.className.replace("with-panel-right-cover","");       
        if (this.profile.isDemoUser) {
          this.$router.load({ url: "home" });
        }
 },
 updated: function () {
  this.$nextTick(function () {            
      this.profile = this.getProfile;  
      if(this.profile.firstName){
        this.isLoadData = true;
      }
      if (this.profile.isDemoUser) {
        this.$router.load({ url: "home" });
      }      
  })
 },
 computed: {
    ...mapState({
      userImage: state => state.editUserProfile.userImage,
      salesPersonFullName:state =>state.common.salesPersonFullName,
      companyName:state =>state.common.companyName,
      companyPhone:state =>state.common.companyPhone,
      customization: state => state.common.customization     
    }),
     ...mapGetters({
      getProfile: "editUserProfile/getUserProfile",
      updatedPhoto: "editUserProfile/getUserProfileImage"
    }),
     borderStyle: function(){     
            var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
            var backgroundStyle = this.customization.mainColor;
            var colorStyle = this.customization.fontColor
            return {
                border: borderStyle, 
                background: backgroundStyle,
                color:colorStyle
            };
     }    
  },
  methods: {
    ...mapActions([
      "editUserProfile/loadUserProfile",
      "editUserProfile/saveUserProfile",
      "editUserProfile/uploadImage",
      "editUserProfile/updateImage",
      "editUserProfile/updateProfile"
    ]),    
    saveUserProfile() {    
      if (!this.isRequestActive) {
        this.profile.profilePhoto = this.userImage;
        this.replaceSpecificSymbols();
        this.saveRequest.isActive = true;
        this.saveRequest.isSuccess = false;        
        this["editUserProfile/saveUserProfile"](this.profile).then(function(response){
          this["editUserProfile/updateProfile"](this.profile);
          this.saveRequest.isSuccess = (response.status == 200);
          setTimeout(function () {
            this.saveRequest.isActive = false;
          }.bind(this),1500);
        }.bind(this));
      }
    },
    replaceSpecificSymbols() {
      this.profile.firstName = this.profile.firstName.replace(/\s+/g, "");
      this.profile.lastName = this.profile.lastName.replace(/\s+/g, "");
      this.profile.mobilePhone = this.profile.mobilePhone.replace(/\D/g, "");
       if(this.profile.mobilePhone[0] !== '+'){
        this.profile.mobilePhone = '+' + this.profile.mobilePhone;
      }  
      if(this.profile.optSmsStatusMessage != 0){
        this.profile.optSmsStatus = this.profile.isOptIn ? 1 : 2;
        this.profile.optSmsStatusMessage = this.profile.isOptIn ? 3 : 2;
      }
    },
    uploadProfileImage(event) { 
      this.uploadedPhoto = true;
      this.saveRequest.isActive = true;      
      this["editUserProfile/updateProfile"](this.profile)
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e => {
        this["editUserProfile/updateImage"](e.target.result);
      }).bind(this);
      reader.readAsDataURL(event.target.files[0]);     
      this["editUserProfile/uploadImage"](event.target.files[0]).then(() => {
        this.saveRequest.isActive = false;
      });
    },
    back() { 
      this["editUserProfile/updateImage"](this.profile.profilePhoto);    
      this.$router.load({ url: "home" });      
    }
  },
  data() {
    return {
      profile: {
        firstName: "",
        lastName: "",
        mobilePhone: "",
        email: "",
        profilePhoto: "",
        optSmsStatus:0,
        optSmsStatusMessage:0,
        optSmsDataChange:"",
        isOptIn:false
      },    
      isRequestActive: false,
      saveRequest:{
        isActive:false,
        isSuccess:false
      },
      isLoadData:false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255);
  text-align: center;
  z-index: 100;
}
.looping-rhombuses-spinner {
  display: inline-block;
}
.success_icon {
  width: 30px;
  height: 30px;
  display: block;
}
.success_msg{
  display: flex;
  justify-content: space-around;
  align-content: center;
  margin-bottom: 20px;
}
.success_msg > *
{
  margin:unset;
}
.none {
  display: none;
}
.list-block .item-content{
  -webkit-justify-content: flex-start;
    justify-content: flex-start;
}
.form_row_right {
    border-bottom: 1px solid #d6d6d6;
}
.font-red{
  color:red !important;
}
</style>



// WEBPACK FOOTER //
// edit-user-profile.vue?fcf4eea0